export const gameControls = {
    data() {
        return {
            scoresList: [300000, 150000, 100000, 80000, 50000, 30000, 20000, 18000, 15000, 12000, 10000, 7000, 4000, 2500, 1000, 500],
            ansin: ['a', 'b', 'c', 'd'],
            friendAnswersQ: [
                "Ha-ha, yaxshi savol. Javob aniq - ",
                "Menga ishonganingdan xursandman. Menimcha javob - ",
                "Ertaroq telefon qilmaysanmi?! Buni javobi oson-ku. Javob -",
                "Savolni to'g'ri o'qidingmi? Agar to'g'ri o'qigan bo'lsang, javob -",
            ],
            
            friendAns: "",
            friendHelpShow: false,
            doubleCheckHelpShow: false,
            getHelp: false,
            getHelpShow: false,

            doubleCheck: {
                check1: false,
                check2: false,
                corrected: "",
                incorrected: "",
                ok: false
            },

            incAns: [],

            games: {
                running: false,
                totalScore: 0,
                timer: 45,
                currentScore: 500,
                quizeNum: 0,
                stepScore: 0,
                currentQuize: "",
                answers: [],
                currentAnswer: "",
                checked: "",
                corrected: "",
                incorrected: "",
                loaded: false,
            },

            connection: true,
            connErr: "",

            gameOver: {
                over: false,
                status: "",
                title: "",
            },

            quizes: [],

            helpers: {
                replaceQuiz: false,
                removeWrong: false,
                doubleChoise: false,
                friendHelp: false
            },
            
        }
    },

    methods: {
        help(val) {
            const help = this.helpers
            if (!this.getHelp) {
                if (val == 1 && !this.helpers.replaceQuiz) {
                    help.replaceQuiz = true
                    this.games.running = false
                    this.games.quizeNum += 1
                    this.gameStart()
                }
    
                if (val == 2 && !help.removeWrong) {
                    help.removeWrong = true
                    let loop = 0
                    while (loop < 2) {
                        let rand = Math.floor(Math.random() * 4)
                        let qz = this.quizes[this.games.quizeNum][this.ansin[rand]] 
                        if (qz !== this.quizes[this.games.quizeNum][this.games.currentAnswer]
                            && !this.incAns.includes(qz)) {
                            this.incAns.push(qz)
                            loop += 1
                        }
                    }
                    this.getHelp = true
                }
    
                if (val == 3 && !help.doubleChoise) {
                    help.doubleChoise = true
                    this.doubleCheckHelpShow = true
                    this.doubleCheck.ok = true
                    this.getHelp = true
                }
    
                if (val == 4 && !help.friendHelp) {
                    help.friendHelp = true
                    this.friendHelpShow = true
                    let friendAnswer = ""
                    let random = Math.floor(Math.random() * 10) + 1;
                    if (random > 3) {
                        friendAnswer = this.quizes[this.games.quizeNum][this.games.currentAnswer]
                    } else {
                        friendAnswer = this.quizes[this.games.quizeNum][this.ansin[Math.floor(Math.random() * 4)]]
                    }
                    this.friendAns = this.friendAnswersQ[Math.floor(Math.random() * 4)] + friendAnswer
                    this.getHelp = true
                }
            } 
            
            else {
                this.getHelpShow = true
            }
        },

        gameStart() {
            if (!this.games.running) {
                this.games.currentQuize = this.quizes[this.games.quizeNum].quize
                this.games.currentAnswer = this.quizes[this.games.quizeNum].correct
                const answers = []
                for (var i=0; i<4; i++) {
                    answers.push({
                        ind: this.ansin[i],
                        value: this.quizes[this.games.quizeNum][this.ansin[i]]
                    })
                }
                this.games.answers = answers.sort(function(){return 0.5 - Math.random()})
                this.games.running = true
            }
        },

        check(answer, disable = false) {
            if (this.games.running && !disable) {

                if (this.doubleCheck.ok) {
                    if (this.doubleCheck.check1) {
                        this.doubleCheck.check2 = answer
                        this.games.running = false
                    } else {
                        this.doubleCheck.check1 = answer
                        this.games.checked = answer
                    }
                } 
                
                else {
                    this.games.running = false
                    this.games.checked = answer
                }
    
                setTimeout(() => {
                    if (answer == this.games.currentAnswer || this.doubleCheck.check2 == this.games.currentAnswer) {
                        if (this.doubleCheck.ok) {
                            if (this.doubleCheck.check2) {
                                this.doubleCheck.corrected = answer
                            } else {
                                this.games.corrected = answer
                            }
                            this.doubleCheck.ok = false
                        }

                        else {
                            this.games.corrected = answer
                        }

                        this.games.quizeNum += 1
                        this.games.stepScore += 1
                        this.games.totalScore += this.games.currentScore
                        this.games.currentScore = this.scoresList[this.scoresList.length - this.games.stepScore - 1]
                        
                        setTimeout(() => {
                            if (this.games.stepScore >= 16) {
                                this.gameEnd("winner")
                            } 
                            
                            else {
                                this.reset()
                                this.gameStart()
                            }
                        }, 1000);
                    } 
                    
                    else {
                        if (this.doubleCheck.ok) {
                            if (this.doubleCheck.check2) {
                                this.doubleCheck.incorrected = answer
                                this.doubleCheck.ok = false
                            } else {
                                this.games.incorrected = answer
                            }
                        }

                        else {
                            this.games.incorrected = answer
                        }
                        
                        if (!this.doubleCheck.ok) {
                            setTimeout(() => {
                                this.games.corrected = this.games.currentAnswer
                                
                                setTimeout(() => {
    
                                    this.gameEnd("incorrect")
                                }, 600);
                            }, 500);
                        }
                    }
                }, 1000);
            }
        },

        reset() {
            const g = this.games
            g.timer = 45;
            g.currentAnswer = "";
            g.checked = ""
            g.corrected = ""
            g.incorrected = ""
            g.answers = []
            this.incAns = []
            this.friendAns = ""
            this.doubleCheck.check1 = "",
            this.doubleCheck.check2 = "",
            this.doubleCheck.corrected = "",
            this.doubleCheck.incorrected = "",
            this.doubleCheck.ok = false,
            this.getHelp = false
        },

        gameEnd(status) {
            this.gameOver.status = status
            this.gameOver.over = true
            this.friendHelpShow = false
            this.doubleCheckHelpShow = false
            this.scoresShow = false
            
            if (status == "timeOut") {
                this.games.running = false
                this.gameOver.title = "Vaqt tugadi!"
            } 

            else if (status == 'incorrect') {
                this.gameOver.title = "Noto'g'ri javob!"
            }

            else if (status == 'winner') {
                this.games.running = false
                this.gameOver.title = "Siz yutdingiz!"
            }
            
        },

        newGame() {
            if (this.games.running == false) {
                this.reset()
                this.games.loaded = false
                this.connection = null
                this.connErr = ""
                this.games.totalScore = 0
                this.games.currentScore = 500
                this.games.quizeNum = 0
                this.games.stepScore = 0
                this.games.currentQuize = ""
                this.quizes = []
                this.helpers.replaceQuiz = false,
                this.helpers.removeWrong = false,
                this.helpers.doubleChoise = false,
                this.helpers.friendHelp = false
                this.getQuizes()
                this.gameOver.over = false
                setTimeout(() => {
                    this.gameStart()
                }, 1000);
            }
        },

        getQuizes() {
            this.$http.get("https://millbht1.herokuapp.com/api/quizes/pack?user=admin&password=accession")
            .then(response => {
                return response.json()
            })
            .then(data => {
                this.quizes = data
                this.connection = false
            }, error => {
                this.connection = true
                this.connErr = error
            })
        }
    },

    created() {
        this.newGame()
    },

    watch: {
        "games.running"() {
            const countDown = setInterval(() => {
                this.games.timer -= 1

                if (this.games.running == false) {
                    clearInterval(countDown)
                    this.games.timer += 1
                }  

                if (this.games.timer == 0) {
                    clearInterval(countDown)
                    this.gameEnd("timeOut")
                }
            }, 1000)  
            
            this.games.loaded = true
        }
    }
}